import React,{ useContext} from "react";
import { Button } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import { useHistory } from "react-router-dom";
import { SecurityContext } from "context/SecurityContextProvider";

const Botones=()=>{
    const { getUsuarioAutenticado } = useContext(SecurityContext);
    const isSDF = getUsuarioAutenticado().empresaSeleccionada?.ruc === "20330791684" ? true : false;
    let history = useHistory();
    const isSDFEnergia = getUsuarioAutenticado().empresaSeleccionada?.ruc === "20512436090" ? true : false;

    const BotonCrearTipoAbsentismo = () =>{

       const onClickBtnCrearTipoAbsentismo = () =>{
            history.push("/tipoAbsentismo/crear");
        }
        return(
            <Button
            type="primary"
            icon={<PlusOutlined/>}
            onClick={onClickBtnCrearTipoAbsentismo}            
            >
                {(isSDF || isSDFEnergia) ? "Crear Tipo Movimiento":"Crear Tipo Absentismo"}
            </Button>
        )

    }
    return(
        <React.Fragment>
            <BotonCrearTipoAbsentismo/>
        </React.Fragment>
    )

}
export default Botones;